import request from '../../utils/request'
import {BASEURL,AGXPARTNER,AGXCOLLEGE,AGXRELATION} from '../../utils/common'
// 文章列表
export function login(params) {
    return request({
        url:BASEURL+AGXPARTNER+'/v1/sso/sys/login/pwd',
        method: 'post',
        data: params
    })
}












// WEBPACK FOOTER //
// ./src/api/partner/login.js